import { ComuniLocalService } from './../../services/comuni-local.service';
import { Component, OnInit, Input, Output } from '@angular/core';
import Comune from 'src/app/models/comune.model';

@Component({
  selector: 'app-comuni',
  templateUrl: './comuni.component.html',
  styleUrls: ['./comuni.component.scss'],
})
export class ComuniComponent implements OnInit {
  @Input() comuneselezionato: any;
  provinciaselezionato: any;
  comuni: Array<Comune>;
  comunifiltrati: Array<Comune>;
  province: Array<any>;

  constructor(private comuniservice: ComuniLocalService) {
    this.province=comuniservice.province;
    this.comuni=comuniservice.comuni;
    // console.log(this.comuni);
    // console.log(this.province);
   }

  async ngOnInit() {
    //this.comuni = await this.comuniservice.list();
    //this.provinciaselezionato=this.province[0];
  }

  filtra(){
    // eslint-disable-next-line @typescript-eslint/quotes
    this.comuneselezionato="";
    console.log('FILTRO: ',this.provinciaselezionato);
    this.comunifiltrati=this.comuni.filter((x)=> x.provincia===this.provinciaselezionato);
  }
}
